import React from "react";
import Section from "../components/primatives/Section";
import SectionHeader from "../components/primatives/SectionHeader";
import AccountSections from "../components/AccountSections";
import ActionButton from "../components/primatives/ActionButton";
import SignupButton from "../components/primatives/SignupButton";
import Input from "../components/primatives/Input";
import { FiLock, FiUser, FiShield } from "react-icons/fi";

import state from "../helpers/state";
import { toast } from "react-toastify";
import VerifyPhone from "../components/VerifyPhone";

class Account extends React.Component {
  constructor(props) {
    super(props);

    const { search } = props.location;
    let loadState = this.props.helpers.loadState();

    // calculate a phonenumber (if provided for verification)
    let phoneNumber = "";
    if (search) phoneNumber = search.split("=")[1];

    console.log("ph:", phoneNumber);

    this.state = {
      name: loadState.backup ? loadState.backup.account : "",
      key: "",
      phoneNumber,
      isLoading: false,
      loadState,
    };
  }

  updateUsername = (name) => {
    this.setState({ name });
  };

  updateKey = (key) => {
    this.setState({ key });
  };

  logout = async () => {
    // logout user..
    state.reset();
    await this.props.helpers.refreshApp();
    // reset state..
    this.setState({ loadState: this.props.helpers.loadState() });
    // toast
    toast.success("You have logged out.");
  };

  login = async (e) => {
    // verify key belongs to user
    // then store in localstorage.
    if (e) {
      e.preventDefault();
      this.setState({ isLoading: true });
    }
    const { name, key } = this.state;

    try {
      let put = this.props.helpers.put();
      await put.verify(name, key);
      await state.set("account", { name, key }); // save new creds..
      await this.props.helpers.refreshApp();
      this.props.history.push("/?login=true"); // redirect..
    } catch (e) {
      toast.error("Oops. Those credentials are invalid.");
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { loadState } = this.state;
    const { account } = loadState;

    // --------------------

    // not logged in.
    if (!account.key) {
      if (this.state.phoneNumber)
        return (
          <div>
            <VerifyPhone
              phoneNumber={this.state.phoneNumber}
              updateUsername={this.updateUsername}
              updateKey={this.updateKey}
              login={this.login}
              helpers={this.props.helpers}
            />
          </div>
        );

      return (
        <div>
          <div className="mb-4"><SignupButton /></div>

          <Section>
            <form onSubmit={this.login}>
              <div className="mb-4">
                <SectionHeader>
                  <div className="text-xl">
                    <FiUser /> Username
                  </div>
                </SectionHeader>
                <Input
                  type="text"
                  placeholder="putx11111111"
                  value={this.state.name}
                  onChange={(e) => this.updateUsername(e.target.value)}
                  required={true}
                />
              </div>
              <div className="mb-6">
                <SectionHeader>
                  <div className="text-xl">
                    <FiLock /> Password / Auth
                  </div>
                </SectionHeader>
                <Input
                  type="password"
                  placeholder="******************"
                  value={this.state.key}
                  onChange={(e) => this.updateKey(e.target.value)}
                  required={true}
                />
                <p className="text-gray-500 text-xs mt-1">
                  <b>Secure+</b> | <FiShield /> password never leaves device.
                </p>
              </div>
              <div className="flex items-lcentereft justify-between">
                <ActionButton
                  type="submit"
                  style={{ maxWidth: "110px" }}
                  isLoading={this.state.isLoading}
                >
                  Sign In
                </ActionButton>

                <div>&nbsp;</div>
                <button
                  className="inline-block align-baseline font-bold text-sm text-indigo-500 hover:text-indigo-800"
                  href="#"
                >
                  Forgot Password?
                </button>
              </div>
            </form>
          </Section>

          {/* ----- */}
        </div>
      );
    }

    // --------------------

    // logged in.
    return (
      <AccountSections
        helpers={this.props.helpers}
        account={account}
        logout={this.logout}
      />
    );

    // --------------------
  }
}

export default Account;
